import { Link } from "react-router-dom";
import LegalLayout, { Section, Mail } from "@/pages/legal/LegalLayout";

// Google Play requires a public web page where users can request account and
// data deletion without installing or signing in to the app, and which states
// what is deleted and what is kept.

export default function DeleteAccount() {
    return (
        <LegalLayout
            testId="delete-account-page"
            eyebrow="Your data"
            title="Delete your account"
            intro="You can delete your Day Dreamer account and everything in it at any time, from the app or by email."
        >
            <Section title="From the app">
                <ol className="list-decimal pl-5 space-y-1.5">
                    <li>Sign in and open <strong className="text-foreground">Settings</strong>.</li>
                    <li>Choose <strong className="text-foreground">Delete account</strong>.</li>
                    <li>Type DELETE to confirm.</li>
                </ol>
            </Section>

            <Section title="Without signing in">
                <p>Email <Mail /> from the address on your account and ask us to delete it. We'll confirm when it's done.</p>
            </Section>

            <Section title="What happens next">
                <p>Your account and writing are hidden immediately. After <strong className="text-foreground">30 days</strong> they are permanently deleted. If you change your mind, sign in again within those 30 days and everything is restored.</p>
            </Section>

            <Section title="What is deleted">
                <p>Your account details, every novel, chapter, scene, character, plot note and version, uploaded covers and backgrounds, beta-reader comments, AI usage records, messages you sent us, and our copy of your purchase records.</p>
            </Section>

            <Section title="What is kept">
                <p>Stripe and Google keep their own records of payments you made, as the law requires. We keep nothing else.</p>
            </Section>

            <Section title="Subscriptions">
                <p><strong className="text-foreground">Deleting your account does not cancel a Google Play subscription.</strong> Cancel it in the Google Play app too, or Google will keep billing you. Plans bought on the web never renew automatically, so there is nothing to cancel there.</p>
            </Section>

            <Section title="Keep a copy first">
                <p>Deletion can't be undone after 30 days. To keep your writing, export it from the web app as .docx, .epub, or .pdf before you delete. More detail is in our <Link to="/privacy" className="text-primary underline underline-offset-2">privacy policy</Link>.</p>
            </Section>
        </LegalLayout>
    );
}
